<template>
  <v-navigation-drawer class="flex-grow-0 ml-4" permanent right>
    <!-- @transitionend="transitioned"
    :mini-variant.sync="mini" -->
    <!-- :expand-on-hover="!open" -->
    <v-list dense>
      <!-- <v-list-item @click.stop="close">
        <v-list-item-icon>
          <v-icon>{{ mini ? "mdi-chevron-left" : "mdi-chevron-right" }}</v-icon>
        </v-list-item-icon>
      </v-list-item> -->
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-list-item v-show="mini" v-on="on">
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("common.newActivity") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-show="!mini">
            <v-btn block color="primary" dark v-on="on">
              {{ $t("common.newActivity") }}
              <v-icon right>mdi-menu-down</v-icon>
            </v-btn>
          </v-list-item>
        </template>
        <v-list>
          <v-list-item
            @click="
              hotel = false;
              eventDialog = true;
            "
          >
            <v-list-item-title>{{ $t("common.newEvent") }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="travelDialog = true">
            <v-list-item-title>{{ $t("common.newTravel") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="
              hotel = true;
              eventDialog = true;
            "
          >
            <v-list-item-title>{{ $t("common.newHotel") }}</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item @click="flightDialog = true;">
                <v-list-item-title>New Flight</v-list-item-title>
                  </v-list-item>-->
        </v-list>
      </v-menu>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-list-item v-show="mini" v-on="on">
            <v-list-item-icon>
              <v-icon>mdi-minus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("itinerary.itinerary.bulkActions") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-show="!mini">
            <v-btn block color="primary" outlined dark v-on="on">
              {{ $t("itinerary.itinerary.bulkActions") }}
              <v-icon right>mdi-menu-down</v-icon>
            </v-btn>
          </v-list-item>
        </template>
        <v-list>
          <v-list-item @click="excelDialog = true">
            <v-list-item-content>
              <v-list-item-title>{{ $t("itinerary.itinerary.importExcel") }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $t("itinerary.itinerary.importExcelSubtitle")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="exportDialog = true">
            <v-list-item-content>
              <v-list-item-title>{{ $t("itinerary.itinerary.export") }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $t("itinerary.itinerary.exportSubtitle")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- <v-list-item>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="!mini"
              block
              color="primary"
              outlined
              dark
              v-bind="attrs"
              v-on="on"
              @click="excelDialog = true"
            >
              <v-icon left>mdi-file-excel</v-icon>
              {{ $t("itinerary.itinerary.importExcel") }}
            </v-btn>
          </template>
          <span>{{ $t("itinerary.itinerary.importExcelSubtitle") }}</span>
        </v-tooltip>
      </v-list-item> -->

      <div class="d-flex flex-row justify-space-between align-center">
        <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <div>{{ calendar | strToDate("MMMM yyyy") }}</div>
        <v-btn icon class="ma-2" @click="$refs.calendar.next()">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>

      <v-calendar
        ref="calendar"
        v-model="calendar"
        color="primary"
        class="mt-3 px-1"
        style="height: 250px"
        :start="calendarStart"
        :end="calendarEnd"
        :weekday-format="formatWeekDay"
      >
        <template v-slot:day-label="{ month, day, present }">
          <div v-if="present" class="mx-auto">
            <div
              class="rounded-circle primary white--text mx-auto text-center"
              style="width: 24px; height: 24px"
            >
              {{ day }}
            </div>
          </div>
          <div v-else :class="colorMonth(month)">{{ day }}</div>
        </template>

        <!-- <template v-slot:event="{  }"> </template> -->
        <template v-slot:day="{ date }">
          <div v-if="activityDates.includes(date)">
            <div class="rounded-circle primary mx-auto" style="width: 4px; height: 4px"></div>
          </div>
          <!-- <v-row class="fill-height"> -->
          <!-- <template v-if="past && tracked[date]"> -->
          <!-- <v-sheet
                v-for="(percent, i) in tracked[date]"
                :key="i"
                :title="category[i]"
                :color="colors[i]"
                :width="`${percent}%`"
                height="100%"
                tile
              ></v-sheet> -->
        </template>
        <!-- </v-row> -->
        <!-- </template> -->
      </v-calendar>

      <!-- <v-subheader class="text-h6 mt-3">Filters</v-subheader> -->
      <!-- <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-format-list-bulleted-type</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("itinerary.itinerary.activityType") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item v-for="item in types" :key="item.title" @click="updateFilters(item.id)">
        <v-list-item-icon>
          <v-icon v-if="typeFilters.includes(item.id)" size="27" :color="item.color"
            >mdi-check-circle</v-icon
          >
          <div
            v-else
            :style="`width:24px;height:24px;border-radius:13px;background-color:${
              typeFilters.length === 0 ? item.color : 'grey'
            };`"
          ></div>
        </v-list-item-icon>

        <v-list-item-content>
          {{ item.title }}
        </v-list-item-content>
      </v-list-item>
      <div v-if="isSuperAdmin">
        <v-divider class="my-2"></v-divider>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("navbar.menu.subgroups") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-for="item in subgroups" :key="item.id" @click="updateSubgroups(item.id)">
          <v-list-item-icon>
            <v-icon v-if="value.includes(item.id)" size="27" :color="item.color"
              >mdi-checkbox-marked</v-icon
            >
            <div
              v-else
              :style="`width:24px;height:24px;border-radius:6px;background-color:${item.color};`"
            ></div>
          </v-list-item-icon>

          <v-list-item-content>
            {{ item.title }}
          </v-list-item-content>
          <v-list-item-icon @click="editSubgroup(item.id)">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item @click="subgroupDialog = true">
          <v-list-item-icon>
            <v-icon color="primary">mdi-plus-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="primary--text">
            <v-list-item-title>{{ $t("subgroup.add_new") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>
    <NewEvent
      :key="newEventKey"
      :value="eventDialog"
      @closed="
        eventDialog = false;
        newEventKey++;
      "
      :hotel="hotel"
    />
    <NewTravel
      :key="newTravelKey"
      :value="travelDialog"
      @closed="
        travelDialog = false;
        newTravelKey++;
      "
    />
    <ExcelUpload
      :dialog="excelDialog"
      :key="excelKey"
      @closed="
        excelDialog = false;
        excelKey++;
      "
    />
    <SubgroupInfo
      :dialog="subgroupDialog"
      :key="subgroupDialogKey"
      :subgroupkey="editingSubgroup"
      :noActivator="true"
      @closed="
        subgroupDialog = false;
        editingSubgroup = null;
        subgroupDialogKey++;
      "
    />
    <ItineraryExporter
      :dialog="exportDialog"
      :key="exportKey"
      @closed="
        exportDialog = false;
        exportKey++;
      "
    />
    <!-- <NewFlight
      :key="newFlightKey"
      :value="flightDialog"
      @closed="flightDialog = false; newFlightKey++"
        />-->
  </v-navigation-drawer>
</template>

<script>
import NewEvent from "@/components/CurrentTrip/Itinerary/NewEvent";
import NewTravel from "@/components/CurrentTrip/Itinerary/NewTravel";
import SubgroupInfo from "@/components/CurrentTrip/Subgroup/SubgroupInfo";
import ExcelUpload from "@/components/Excel/ExcelUpload";
import ItineraryExporter from "@/components/CurrentTrip/Itinerary/ItineraryExporter";
// import NewFlight from "@/components/CurrentTrip/Itinerary/NewFlight";

export default {
  props: ["subgroups", "value", "typeFilters", "isSuperAdmin", "activityDates"],
  components: {
    NewEvent,
    NewTravel,
    SubgroupInfo,
    ExcelUpload,
    // newFlight
    ItineraryExporter,
  },
  data() {
    return {
      mini: false,
      open: false,
      eventDialog: false,
      travelDialog: false,
      flightDialog: false,
      subgroupDialog: false,
      exportDialog: false,
      subgroupDialogKey: 400,
      editingSubgroup: null,
      newEventKey: 100,
      newTravelKey: 200,
      newFlightKey: 300,
      excelKey: 10,
      excelDialog: false,
      exportKey: 0,
      hotel: false,
      calendar: this.$options.filters.zonedDate(new Date(), "yyyy-MM-dd", "UTC"),
      types: [
        {
          id: "destination",
          title: "In destination",
          color: "#F7A400",
        },
        {
          id: "virtual",
          title: "Virtual event",
          color: "#8D72E8",
        },
        {
          id: "hotel",
          title: "Hotel",
          color: "#FF6B48",
        },
        {
          id: "travel",
          title: "Transportation",
          color: "#5297E7",
        },
        // {id:"flight", title: "Flight", color: "#333344" },
      ],
    };
  },
  computed: {
    calendarEvents() {
      return this.$props.activityDates.map((date) => ({
        start: new Date(date),
      }));
    },
    calendarStart() {
      const { trip } = this;
      if (!trip) return null;
      return this.$options.filters.zonedDate(trip.start_date, "yyyy-MM-dd", "UTC");
    },
    calendarEnd() {
      const { trip } = this;
      if (!trip) return null;
      return this.$options.filters.zonedDate(trip.end_date, "yyyy-MM-dd", "UTC");
    },
    trip() {
      return this.$store.state.trip.trip;
    },
  },
  watch: {
    trip(trip) {
      const calendarDate = (() => {
        const now = new Date();
        if (!trip) return now;
        if (now > trip.end_date) return trip.end_date;
        if (now < trip.start_date) return trip.start_date;
        return now;
      })();
      this.calendar = this.$options.filters.zonedDate(calendarDate, "yyyy-MM-dd", "UTC");
    },
  },
  methods: {
    editSubgroup(subgroupId) {
      console.log("edit subgroup");
      this.editingSubgroup = subgroupId;
      this.subgroupDialog = true;
    },
    colorMonth(month) {
      const currentMonth = this.$options.filters.strToDate(this.calendar, "M");
      return month.toString() === currentMonth ? "" : "grey--text";
    },
    formatWeekDay(a) {
      return this.$options.filters.zonedDate(new Date(a.date), "EEEEE", "UTC");
    },
    updateSubgroups(subgroupId) {
      const updated = this.$props.value;
      const checked = updated.includes(subgroupId);
      if (checked) {
        const index = updated.indexOf(subgroupId);
        if (index !== -1) {
          updated.splice(index, 1);
        }
      } else {
        updated.push(subgroupId);
      }
      this.$emit("input", updated);
    },
    updateFilters(itemId) {
      const updated = this.$props.typeFilters;
      const checked = updated.includes(itemId);

      if (checked) {
        const index = updated.indexOf(itemId);
        if (index !== -1) {
          updated.splice(index, 1);
        }
      } else {
        updated.push(itemId);
      }
      this.$emit("typesChanged", updated);
    },
    close() {
      if (!this.mini) {
        this.open = false;
        this.$nextTick(() => {
          this.mini = true;
        });
      } else {
        this.mini = false;
        this.open = true;
      }
    },
    transitioned() {
      this.open = !this.mini;
    },
  },
};
</script>
